import axios from "axios";
import { BASE_URL } from "../../../variables";

export const getMyDiaryDetailsApi = async (
  RecordtypeName,
  dealerCode,
  wssCode
) => {
  if (!RecordtypeName) {
    throw new Error("RecordtypeName is required");
  }

  let options;
  if (RecordtypeName === "Dealer") {
    options = {
      url: `${BASE_URL}/services/data/v62.0/query/?q=SELECT+Id,CreatedDate,Title__c,Observations__c,Dealer_Code__c,WSS_Code_es__c+FROM+Capture_Insight__c++where+(Dealer_Code__c+='${dealerCode}')++order+by+CreatedDate`,
      method: "get",
    };
  } else if (RecordtypeName === "WSS") {
    options = {
      url: `${BASE_URL}/services/data/v62.0/query/?q=SELECT+Id,CreatedDate,Title__c,Observations__c,Dealer_Code__c,WSS_Code_es__c+FROM+Capture_Insight__c++where+(WSS_Code_es__c+='${wssCode}')++order+by+CreatedDate`,
      method: "get",
    };
  }

  try {
    const res = await axios(options);
    return res;
  } catch (error) {
    const errors = error?.response?.data?.[0].message;
    if (errors) {
      return { error: error?.response?.data?.[0].message };
    } else if (error?.code === "ERR_NETWORK") {
      return { error: error?.code };
    } else {
      return { error: "Something went wrong" };
    }
  }
};
